// this is used for polling on the activites page and disabling the next button to ensure that the activities assigned are correct when updating our database
export const FAST_POLL = 5000; // 5 sec
export const SLOW_POLL = 600000; // 10 mins
